<!-- Caret (top-right) toggles collapsed (paginated) <-> expanded (full grid), like Lighting/Messages. -->
<dropdown-panel title="Scenes" [collapsedContent]="linearView" (toggled)="onPanelToggle($event)">
  <!-- Expanded: grid of all scenes (4 across). "Reorder" turns the tiles into drag handles. -->
  <div class="scenes-grid-head">
    <span class="reorder-hint" *ngIf="editMode">Drag to rearrange</span>
    <button class="edit-toggle" [class.done]="editMode" (click)="toggleEdit()">{{ editMode ? 'Done' : 'Reorder' }}</button>
  </div>
  <div class="scenes-grid" #sceneGrid [class.editing]="editMode" [class.dragging]="!!dragId">
    <button class="card scene-tile" *ngFor="let s of scenes; let i = index; trackBy: trackScene"
            [class.held]="dragId === s.id"
            [style.--accent]="s.color"
            [style.transform]="tileTransform(i, s)"
            (click)="onCardTap(s)"
            (pointerdown)="onPressStart(s); onDragStart(s, i, $event)"
            (pointerup)="onPressEnd(); onDragEnd($event)"
            (pointercancel)="onPressEnd(); onDragEnd($event)"
            (lostpointercapture)="onDragEnd($event)"
            (pointerleave)="onPressEnd()">
      <span class="nm">{{ s.name }}</span>
      <ion-icon class="ic" [class.bounce]="bouncingId === s.id" (animationend)="onBounceEnd()" [name]="s.icon"></ion-icon>
    </button>

    <button class="card add" *ngIf="!editMode" (click)="openEditor()">
      <span class="nm">New</span>
      <ion-icon class="ic" name="add"></ion-icon>
    </button>
  </div>
</dropdown-panel>

<!-- Collapsed: paginated 4-at-a-time; bottom carets slide to the next/previous page. -->
<ng-template #linearView>
  <div class="scenes-pager">
    <!-- Static: outside .scenes-viewport, so the paging track's translateX never
         moves it and swiping across it cannot page scenes. Always rendered — it
         greys itself when there is nothing to control rather than disappearing,
         so it arrives with the rest of home instead of popping in. -->
    <mood-audio-bar></mood-audio-bar>

    <div class="scenes-viewport"
         (pointerdown)="onSwipeStart($event)"
         (pointermove)="onSwipeMove($event)"
         (pointerup)="onSwipeEnd($event)"
         (pointercancel)="onSwipeAbort($event)"
         (lostpointercapture)="onSwipeAbort($event)"
         (pointerleave)="onSwipeEnd($event)">
      <div class="scenes-track"
           [style.transform]="'translateX(calc(' + (-page * 100) + '% + ' + dragDx + 'px))'"
           [style.transition]="swiping ? 'none' : ''">
        <div class="scenes-page" *ngFor="let pg of pages; trackBy: trackPage">
          <ng-container *ngFor="let t of pg; trackBy: trackTile">
            <button *ngIf="t.scene as s" class="card scene-tile"
                    [style.--accent]="s.color"
                    (click)="onCardTap(s)"
                    (pointerdown)="onPressStart(s)"
                    (pointerup)="onPressEnd()"
                    (pointercancel)="onPressEnd()"
                    (pointerleave)="onPressEnd()">
              <span class="nm">{{ s.name }}</span>
              <ion-icon class="ic" [class.bounce]="bouncingId === s.id" (animationend)="onBounceEnd()" [name]="s.icon"></ion-icon>
            </button>

            <button *ngIf="!t.scene" class="card add" (click)="openEditor()">
              <span class="nm">New</span>
              <ion-icon class="ic" name="add"></ion-icon>
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="pager-controls">
      <button class="pager-btn prev" [style.visibility]="page === 0 ? 'hidden' : 'visible'"
              (click)="prevPage()" aria-label="Previous scenes">
        <ion-icon src="assets/dropdown_arrow.svg" size="medium" class="caret caret-left"></ion-icon>
      </button>
      <div class="pager-dots">
        <span class="dot" *ngFor="let pg of pages; let i = index" [class.active]="i === page"></span>
      </div>
      <button class="pager-btn next" [style.visibility]="page >= pages.length - 1 ? 'hidden' : 'visible'"
              (click)="nextPage()" aria-label="Next scenes">
        <ion-icon src="assets/dropdown_arrow.svg" size="medium" class="caret caret-right"></ion-icon>
      </button>
    </div>
  </div>
</ng-template>
